import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormButton } from '@app/core/components/form-field-button/form-field-button.component';
import { LayoutService } from '@app/core/services/layout.service';
import { RememberService } from '@app/core/services/remember.service';
import { UtilityService } from '@app/core/services/utility.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { P2ReleaseNoteItem, P2ReleaseNoteService, P2ReleaseNoteSettingsGet } from '@app/services/p2-release-note.service';

@Component({
    selector: 'tt-p2-release-note',
    templateUrl: './p2-release-note.component.html',
    styleUrls: ['./p2-release-note.component.css'],
    standalone: false,
})
export class P2ReleaseNoteComponent implements OnInit {
    public setting?: P2ReleaseNoteSettingsGet;

    public itemsListReleaseNotes: P2ReleaseNoteItem[] = [];

    public itemState = '';

    public selectedReleaseNoteKeyno = '';

    public readonly tabletSize: MediaQueryList;

    public readonly searchTextButtons: FormButton[] = [{
        id: 'erase',
        icon: 'fas fa-eraser',
        type: 'danger',
        onClick: () => this.clearSearchText(),
    }];

    private navigator?: TTViewNavigator;

    constructor(
        private releaseNotes: P2ReleaseNoteService,
        private remember: RememberService,
        private utility: UtilityService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) navigator?: TTViewNavigator,
    ) {
        this.tabletSize = layout.getMediaQueries().tablet;
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async loadReleaseNotes(): Promise<void> {
        this.itemsListReleaseNotes = await this.releaseNotes.listReleaseNotes();
        this.itemState = this.itemsListReleaseNotes.find((item) => !!item.item_state)?.item_state ?? '';
    }

    public async updateReleaseNotes(): Promise<void> {
        this.selectedReleaseNoteKeyno = '';
        await this.loadReleaseNotes();
    }

    public openReleaseNote(item: P2ReleaseNoteItem): void {
        this.selectedReleaseNoteKeyno = `${item.item_id}`;
    }

    public createReleaseNote(event?: MouseEvent): void {
        if (this.tabletSize.matches && this.itemState === 'p2releasenoteedit') {
            this.selectedReleaseNoteKeyno = '0';
            return;
        }

        const target = { to: 'p2releasenoteedit-test', parms: { p2_releasenote_keyno: '0' } };
        if (event && this.navigator && this.utility.isModifierKeyPressed(event)) {
            void this.navigator.newTab(target);
        } else {
            void this.navigator?.go(target);
        }
    }

    public onSearchTextBlur(): void {
        if (this.setting?.searchtext) void this.rememberSearchText(this.setting.searchtext);
    }

    public clearSearchText(): void {
        if (!this.setting) return;

        this.setting.searchtext = '';
        void this.rememberSearchText('');
    }

    private async rememberSearchText(searchtext: string): Promise<void> {
        await this.remember.remember('w_p2releasenote.searchtext', searchtext);
    }

    public ngOnInit(): void {
        void this.init();
    }

    private async init(): Promise<void> {
        const [setting] = await Promise.all([
            this.releaseNotes.getSettings(),
            this.loadReleaseNotes(),
        ]);
        this.setting = setting;
    }
}
